module.exports = __webpack_public_path__ + "static/media/创造新乐器声音.107dcfa2.png";